import {post} from 'acng/core/service/backend';
import {inject} from 'acng/core/service/ng.js';
import {messengerFeature} from '../config/feature';

/**
 * @param {HTMLElement} context
 * @param {import("acng/amateurPool/factory/Amateur").Amateur} amateur
 * @param {import('../model/message').MessageData} data
 * @returns {Promise<void>}
 */
export const sendVoice = async (context, amateur, data) => {
  const nickname = amateur.getNickname();

  const icebreakerAnswer = await inject('messenger')
    .get(amateur.id)
    .getLastMessage()
    .then((message) => message.isIcebreaker())
    .catch(() => false);

  const {time} = await post('message/voice/send', {
    recipient: data.recipient,
    id: data.payload.id,
    icebreakerAnswer: icebreakerAnswer,
    price: inject('price').get(amateur),
  }, context,
    /** @returns {Promise<{time: number}>} */
    async (error) => {
      if (error.code >= 4000 && error.code < 5000) {
        error.message = await messengerFeature.translate('paymentRequired', {nickname});
      }
      throw error;
    }
  );
  
  data.time = time * 1000;
};
